import styled from 'styled-components/native'

export const PricingCardFooter = styled.View`
  padding: 6px 16px 1px 16px;
  height: 56px;
`
